
export default {
  'm':{
    'sms_login':'短信登录',
    'get_vercode':'获取验证码',
    'change_mobile':'更换手机号',
    'log_reg_agree':'登录/注册代表同意{msg_ss}',
    'old_mobile':'原手机号',
    'new_mobile':'新手机号',
    'agency_reginfo_fill':'公会注册信息填写',
    'audit_res':'审核结果',
    'agency_name':'公会名称',
    'agency_name_input':'请输入公会名称',
    'agency_name_input_note':'注：公会名称建议简短易记，不超过30字',
    'agency_logo':'公会LOGO',
    'agency_logo_unpload_note':'请上传清晰的公会LOGO，支持PNG/JPG/JPEG格式',
    'agency_contact_name':'公会联系人',
    'user_contact_name':'请填写用户平台日常联系的人员名称',
    'agency_contact_phone':'公会联系电话',
    'agency_whatsapp':'公会长WhatsApp',
    'agency_whatsapp_contact':'请输入公会长的WhatsApp联系方式',
    'agency_use_lang':'公会长使用语言',
    'agency_head_ID':'公会长ID',
    'agency_ID_input':'请输入公会长BuzzCast APP的用户ID，用于后期资金发放',
    'reg_country':'注册国家',
    'inhand_ID_photo':'手持证件照片',
    'upload_note_t':'上传注意事项',
    'agency_self_inhand_ID':'必须公会长本人手持护照证件进行拍照',
    'photo_must_clearly':'正面需清晰拍出人物及真实的护照信息',
    'mian_form_country':'主播主要来源国家',
    'invite_code':'邀请码',
    'your_profile_submit_success':'您的资料提交成功！我们会尽快处理。<br>审核结果会发送到公会长的BuzzCastAPP通知中，请注意查看！',
    'your_profile_approved':'您提交的资料审核未通过！拒绝理由“{msg_ss}”。<br>请重新填写或在BuzzCastAPP上联系官方小助手进行咨询。',
    'return_refill':'返回重新填写',
    'success_agency':'恭喜您成功入驻平台，【点我】开始工作吧！',
    'personal_account':'个人账号',
    'my_agency':'我的公会',
    'your_agency_been_forcibly':'您的公会已被平台强制终止合作，您将无法再登录系统。 如有疑问请联系BuzzCastAPP官方小助手或专属运营。',
    'invite_live_join':'邀请主播加入公会链接',
    'base_info':'基本信息',
    'apply_time':'申请时间',
    'join_time':'入驻时间',
    'cooper_status':'合作状态',
    'streamer_manage':'主播管理',
    'sereamer_apply':'主播审批',
    'sereamer_nickname':'主播昵称',
    'remark':'备注',
    'no_remark':'无备注',
    'add_remark':'添加备注',
    'birth':'出生年月',
    'user_status':'用户状态',
    'temporarily_frozen':'临时冻结',
    'permanently_frozen':'永久冻结',
    'fans_num':'粉丝数量',
    'sign_status':'签约状态',
    'sign_ing':'签约中',
    'sign_time':'签约时间',
    'release_time':'解约时间',
    'live_viola_record':'直播违规记录',
    'sign_record':'签约记录',
    'current_contract_status':'当前签约状态',
    'termination_reason':'解约原因',
    'violation_reason':'违规原因',
    'violation_time':'违规时间',
    'processing_result':'处理结果',
    'exported_data':'导出数据',
    'join_agency_apply':'入会审批',
    'audit_status':'审核状态',
    'pending_review':'待审核',
    'pending_HQ_review':'等待总部审核',
    'not_approved_HQ':'总部审核未通过',
    'withdrawn':'已撤销',
    'audit_trail':'审核记录',
    'oper':'操作',
    'other_video_materials':'其他视频材料',
    'pass':'通过',
    'pass_streamer_join_agency_apply':'通过主播入会申请',
    'reject_streamer_join_agency_apply':'拒绝主播入会申请',
    'agree_streamer_join_agency':'同意主播{msg_ss1}成为{msg_ss2}旗下的主播~',
    'reject_streamer_join_agency':'拒绝成员{msg_ss1}成为{msg_ss2}的成员的申请！',
    'img_material':'图片材料',
    'approver':'审批人',

    'user_enter_bind_phone':'请输入手机号码',
    'vericode':'验证码',
    'input_vericode':'请输入验证码',
    'login':'登录',
    'reg':'注册',
    'logout':'退出',
    'search_for':'搜一搜',
    'subscription_closed':'已解约',
    'agency_ID':'公会编码: {msg_ss}',
    'reset':'重置',
    'live_ID':'主播ID',
    'live_record':'直播录屏',
    'email':'邮箱',
    'phone':'手机号码',
    'mastery_lang':'掌握语言',
    'to':'至',
    'cancel':'取消',
    'Confirm':'确定',
    'preview':'预览',
    'rejected':'已拒绝',
    'tip':'提示',
    'i_got_it':'我知道了',
    'cancelled':'已注销',
    'refused':'拒绝',
    'agency_agree':'公会已同意',
    'platform_agree':'平台已同意',
    'user_not_exist':'该用户不存在',
    'user_frozen':'该用户已被冻结',
    'reviewing':'审核中',
    'review_pass':'审核通过',
    'review_failed':'审核未通过',
    'xx_hours':'{msg_ss} 小时',
    'xx_days':'{msg_ss} 天',
    'xx_hour':'{msg_ss} 小时',
    'xx_day':'{msg_ss} 天',
    'xx_year':'{msg_ss} 年',
    'xx_years':'{msg_ss} 年',
    'check_phone_istrue':'请检查手机号是否输入正确',
    'male':'男',
    'female':'女',
    'avatar':'头像',
    'normal':'正常',
    'live_room':'直播间',
    'view':'查看',
    'oper_success':'操作成功',
    'copy_success':'复制成功',
    'new_mobile_already_reg':'新手机号码已注册',
    'general_user':'普通用户',

    'copy':'复制',
    'gender':'性别',
    'submit':'提交',
    'permanent':'永久',
    'agree_agreement':'同意并遵守签约协议',
    'vericode_error':'验证码有误',
    'resend':'重新发送',
    'approved':'已通过',
    'not_approved':'未通过',
    'agency_rejected':'平台已拒绝',
    'select':'选择',
    'search':'搜索',
    'rejection_reason':'拒绝理由',
    'no_data':'数据为空',
    'oper_failed':'操作失败',
    'leave_agency_apply':'退会审批',
    'over_word_limit':'已超出字数限制',
    'delete':'删除',
    'nickname':'昵称',
    'file_is_too_large':'文件过大',

    'community_convention':'Buzzcast社区公约',
    'approval_time':'审批时间',
    'guild_system_title':'BuzzCast社交平台公会系统',
    'return':'返回',
    'img_upload_fail':'图片上传失败',
    'cooper_ing':'合作中',
    'upload_file_format_incorrect':'上传文件格式不正确!',
    'token_invalid':'Token失效，请重新登录！',
    'network_busy':'网络繁忙，请重试',
    'minute':'{msg_ss}分钟',

    'live_room_ID':'直播间ID',

    'scan_code':'BuzzCast APP扫码登录',
    'open_code':'打开BuzzCastApp，点击我的二维码扫一扫',
    'refresh':'刷新',
    'login_confirm':'登录确认',
    'account':'账号信息',
    'user_name':'用户名',
    'edit':'修改',
    'changing':'换绑',
    'mobile_number':'手机账号',
    'mobile_login':'可以使用手机号码{msg_ss}进行登录',
    'appId_login':'可以使用AppID为【{msg_ss}】的账号扫一扫登录',
    'code_login':'未绑定BuzzCastAppID，绑定后可使用二维码扫码登录',
    'verification_log':'未绑定手机号，绑定后可使用手机号和验证码登录',
    'binding_success':'绑定成功',
    'binding_mobile':'绑定手机号',
    'edit_name':'修改用户名',
    'binding_alert':'换绑提示',
    'new_appId':'直接使用新的APPID扫码绑定，原APPID会被直接替换',
    'binding_account':'绑定BuzzCastApp账号',
    'anchor_earings':'主播收益',
    'signing_date':'签约日期',
    'statistical_date':'统计日期',
    'valid_min':'总有效时长(分钟)',
    'valid_day':'有效天(天数)',
    'total_revenue':'总收益',

    'bind':'绑定',
    'please_agree_agree':'请同意协议',
    'note':'说明：本系统所显示的时间均为美国纽约时间(EST)',
    'app_phone':'注册APP的手机号',
    'host_num':'主播数量',
    'enter_host_num':'请输入旗下所有主播数量',
    'platform':'合作平台',
    'statement':'月流水',
    'enter_income':'请输入平均每月的收益',
    'check_commas':'格式不正确。请检查多平台之间是否以英文逗号隔开',
    'submit_success':'您的资料提交成功！我们会尽快处理',
    'usd':'美金',
    'many_platforms':'请输入之前合作过的直播平台，最多20平台',
    'limit_platform':'最多20平台',
    'user_has_delete':'该用户已注销',
    'cant_commit':'您已经是签约主播，无法同时申请公会入驻',
    'cant_commit_1':'您已申请签约主播中，无法同时申请公会入驻',
    'passwd': '密码',
    'passwd_placeholder': '密码支持6到20位',
    'live_rights': '免时长考核',
    'edit_log': '修改记录',
    'edit_time': '修改时间',
    'edit_pwd': '修改密码',
    'old_pwd': '原密码',
    'new_pwd': '新密码',
    'confirm_pwd': '确认密码',
    'forget_pwd': '忘记密码？',
    'email_check': '邮箱格式不正确',
    'phone_pwd_error': '手机号或密码错误',
    'ten_min_error': '请10分钟后再试',
    'phone_bind_error': '手机号码已被绑定其他账号，请更换新的手机号进行绑定。',
    'bc_user_id_tip': 'Buzzcast APP ID',
    'bc_user_id_error': '公会长ID已有人填写，请重新填写',
    'pwd_error': '密码错误',
    'phone_not_reg_error': '账号未注册',
    'pwd_nq': '两次输入的密码不一致',
    'sign_anchor_error': '您已经是签约主播，无法同时申请公会入驻',
    'apply_anchor_error': '您已申请签约主播中，无法同时申请公会入驻',
    'have-expired':'已过期',
    'approval-time':'审批时间',
    'reasons-for-refusal':'拒绝理由',
    'Transfer-grounds':'转会理由',
    'code_expire': '验证码过期，请点击验证码重新刷新',
    'transfer-approval':'转会审批',
    'live_state_placeholder': '开播状态',
    'live_state_open': '正常',
    'live_state_temporary_banned': '禁播',
    'live_state_forever_banned': '永久禁播',
    'live_allowed_time': '允许开播时间',
    'live_banned_time': '禁播周期',
    'deduct_money': '扣B币金额',
    'final_income': '实际收益',
    'select_start_dt': '请选择开始时间',
    'select_end_dt': '请选择结束时间',
    'less_then_end_dt': '开始时间必须小于等于结束时间',
    'System_automatically_through':'系统自动通过',
    'btrade_err': '该公会长ID不可用',

    'mouth_anchor': '月薪主播',
    'day_anchor': '日薪主播',
    'guild_anchor': '公会长奖励（日薪）',
    'mouth_anchor_st': '月薪开始时间',
    'mouth_anchor_et': '月薪结束时间',
    'day_anchor_st': '日薪开始时间',
    'day_anchor_et': '日薪结束时间',
    'all_award_bcoin': '日薪奖励总收益',
    'live_hour': '直播有效时长奖励',
    'salary_day': '日期',
    'day_in_come': '公会当天收益(B币)',
    'award_ration_flag_str': '奖励比例',
    'payable_money': '公会长B币奖励',
    'host_bcoins': '主播收益B币',
    'total_official': '官方奖励B币总数',
    'actual_bcoins_awarded': '实际奖励B币',



    'change_bound_account': '更换绑定帐号',
    'agent_id_form': '公会长ID:',
    'BuzzCast_verification_code': 'BuzzCast验证码:',
    'send_success': '发送成功',
    'account_changed_successfully': '绑定帐号更换成功。',
    'invite_guild_url': '邀请成为BuzzCast公会长链接:{msg_ss}',
    'invite_guild_code': '我的邀请码:{msg_ss}',
    'save': '保存',
    'compile': '编辑',
    'agent_nvitation_eward': '公会长邀请奖励',
    'agent_name': '公会长昵称',
    'guild_id': '公会编码',
    'guild_income_30days': '近30天公会收益',
    'guild_invite_income_30days': '近30天邀请公会收益',
    'agency_commission_ratio': '代理佣金比例',
    'invite_income_bcoins': '邀请奖励B币',
    'id_not_exist': '该 ID 不存在',
    'reward_distribution_status': '奖励发放状态',
    'must_number': '您输入的内容必须是纯数字格式。',
  },
}



// WEBPACK FOOTER //
// ./src/i18n/lang/zh.js